<template>
  <AchievementPicker />
  <ExtraOptionPicker />
  <OptionPicker />
  <ChampionsPicker />
  <RolesPicker :select-only-one-role="true" :max1="true" />
  <PlatformPicker />
</template>

<script setup>
import PlatformPicker from "../commonpickers/PlatformPicker.vue";
import RolesPicker from "../lol/pickers/RolesPicker.vue";
import ExtraOptionPicker from "./pickers/ExtraOptionPicker.vue";

import OptionPicker from "./pickers/OptionPicker.vue";
import ChampionsPicker from "../commonpickers/ChampionsPicker.vue";
import AchievementPicker from "./pickers/AchievementPicker.vue";

const checkoutStore = useCheckoutStore();
const gameStore = useGameStore();

const handleDetails = () => {
  checkoutStore.clearCheckout();
  checkoutStore.setOneRole({
    roleId: gameStore.getGame.roles[0]?.id,
  });
  checkoutStore.setServer(gameStore.getGame.servers[0]?.id);

  checkoutStore.setGameAndPack({
    game: gameStore.getGame.id,
    pack: gameStore.getGamePack.id,
    fullGame: gameStore.getGame,
    fullPack: gameStore.getGamePack,
  });
  checkoutStore.setPlatform({
    platform: 1,
  });
};

handleDetails();
onNuxtReady(() => {
  checkoutStore.setCalculating();
});
</script>
